import AdapterJS from "adapterjs";
import Browser from "../misc/browser";

export default {
  detect: () => {
    return new Promise((resolve, reject) => {
      let adapterJsInitialized = false;

      if (Browser.supportsWebRtc() === false) {
        reject();
      }

      AdapterJS.webRTCReady(function(isUsingPlugin) {
        adapterJsInitialized = true;
        resolve(isUsingPlugin);
      });

      //Safety catch if AdapterJS callbacks isnt called
      setTimeout(function() {
        if (adapterJsInitialized === false) {
          reject();
        }
      }, 2000);
    });
  },
};






// WEBPACK FOOTER //
// ./src/misc/webrtchelper.js